import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {PaymentType} from '@core/models/payment.model';
import {environment} from '../../../../../environments/environment';

interface MethodOption {
  type: PaymentType;
  label: string;
  icon: string;
}

@Component({
  selector: 'payment-method-choice',
  templateUrl: './payment-method-choice.component.html',
  styleUrls: ['./payment-method-choice.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentMethodChoiceComponent {
  @Input() selectedType: PaymentType | null = null;
  @Output() chosen = new EventEmitter<PaymentType>();
  @Output() selectionChange = new EventEmitter<PaymentType>();

  private readonly allMethods: MethodOption[] = [
    {type: 'bank_card', label: 'Банковская карта', icon: 'bank-card'},
    {type: 'invoice', label: 'Счёт на юр. лицо', icon: 'case'},
    {type: 'test', label: 'Тестовая', icon: 'test'},
  ];

  /** Тестовый способ оплаты доступен только вне production. */
  get methods(): MethodOption[] {
    return environment.production
      ? this.allMethods.filter(m => m.type !== 'test')
      : this.allMethods;
  }

  trackByType(_: number, m: MethodOption): PaymentType {
    return m.type;
  }

  choose(type: PaymentType): void {
    this.chosen.emit(type);
    this.selectionChange.emit(type);
  }
}
